var Vendd = (function (Vendd) {
    'use strict';

    Vendd.OnlineOrdersHistory = (function (OnlineOrdersHistory) {

        OnlineOrdersHistory.Messages = (function (Messages) {

            Messages.GetOrderDetails = function (orderId) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OnlineOrdersHistory.Messages.GetOrderDetails', orderId);
            };
            Messages.GetOrderDetails.className = 'Vendd.OnlineOrdersHistory.Messages.GetOrderDetails';

            Messages.GetOrderDetailsSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OnlineOrdersHistory.Messages.GetOrderDetailsSuccess', response);
            };
            Messages.GetOrderDetailsSuccess.className = 'Vendd.OnlineOrdersHistory.Messages.GetOrderDetailsSuccess';

            Messages.GetOrderDetailsFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OnlineOrdersHistory.Messages.GetOrderDetailsFailure', response);
            };
            Messages.GetOrderDetailsFailure.className = 'Vendd.OnlineOrdersHistory.Messages.GetOrderDetailsFailure';

            return Messages;

        })(OnlineOrdersHistory.Messages || {});

        return OnlineOrdersHistory;

    })(Vendd.OnlineOrdersHistory || {})

    return Vendd;

})(Vendd || {});
